<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">หมุนวงล้อ : {{ spinName }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="spinwheel">
          <div id="wheelOfFortune">
            <canvas id="wheel" width="350" height="350"></canvas>
            <div id="spin">หมุน</div>
          </div>
        </div>

        <b-table
          class="m-t-20 coupon-table"
          :data="coupons"
          :paginated="true"
          :per-page="couponPerPage"
          :current-page.sync="currentPage"
        >
          <template v-slot:default="{ row, index }">
            <b-table-column label="ลำดับ" numeric v-if="row.prize">
              {{ (currentPage - 1) * couponPerPage + (index + 1) }}
            </b-table-column>
            <b-table-column label="รางวัล" centered v-if="row.prize">
              <div>{{ row.prize.slice.label }}</div>
              <div>{{ row.prize.name }}</div>
            </b-table-column>
            <b-table-column label="จำนวน" numeric v-if="row.prize">
              {{ row.amount }}
            </b-table-column>
            <b-table-column label="" centered v-if="row.prize">
              <b-button
                @click="onClickClaim(row)"
                size="is-small"
                type="is-light"
              >
                รับ
              </b-button>
            </b-table-column>
          </template>
        </b-table>
      </section>
    </div>

    <modal-spin-prize
      v-if="modalPrizeActive"
      :is-active="modalPrizeActive"
      :prize="prize"
      @closeModal="closeModalPrize"
    />

    <modal-spin-claim
      v-if="modalClaimActive"
      :is-active="modalClaimActive"
      :coupon="claimingCoupon"
      @confirmModal="confirmModalClaim"
      @cancelModal="cancelModalClaim"
    />
  </div>
</template>

<script>
import apiSpin from '@/api/spin'
import i18n from '@/language'

import ModalSpinPrize from '@/views/user/components/modals/spin/Prize'
import ModalSpinClaim from '@/views/user/components/modals/spin/Claim'

export default {
  name: 'ModalSpin',
  components: { ModalSpinPrize, ModalSpinClaim },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sectors: [],
      elSpin: null,
      elWheel: null,
      tot: 0,
      ctx: null,
      dia: 0,
      rad: 0,
      PI: Math.PI,
      TAU: 2 * Math.PI,
      arc: 0,
      friction: 0.991, // 0.995=soft, 0.99=mid, 0.98=hard
      angVelMin: 0.002, // Below that number will be treated as a stop
      angVelMax: 0, // Random ang.vel. to accelerate to
      angVel: 0, // Current angular velocity
      sectorIndex: 0, // Current sector index
      ang: 0, // Angle rotation in radians
      oldAng: 0,
      angOffset: 2 * Math.PI * 0.75, // needle is north
      spinAnimation: null,
      animationFrameId: null,
      isSpinning: false,

      modalPrizeActive: false,
      modalClaimActive: false,

      coin: 0,
      prize: null,
      claimingCoupon: null,
      coupons: [],
      spinName: '',

      currentPage: 1,
      couponPerPage: 3
    }
  },
  mounted() {
    this.setup()
  },
  computed: {},
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    },
    setSectorColors() {
      this.sectors = this.sectors.map(sector => {
        return { ...sector, color: sector.bgColor }
      })
    },
    async setup() {
      let loading = this.$loading.show()

      const setupInfo = await apiSpin.setup()
      this.spinName = setupInfo.result.activeSpinwheel.name
      this.sectors = setupInfo.result.activeSpinwheel.slice
      this.coin = setupInfo.result.userCoin
      this.prize = null
      this.setSectorColors()

      const coupons = await apiSpin.getCoupon()
      this.coupons = coupons

      this.elWheel = document.querySelector('#wheel')
      this.ctx = this.elWheel.getContext`2d`
      this.tot = this.sectors.length
      this.dia = this.ctx.canvas.width
      this.rad = this.dia / 2
      this.angVelMax = 0
      this.angVel = 0
      this.ang = 0
      this.arc = this.TAU / this.tot

      this.elSpin = document.querySelector('#spin')
      this.elSpin.addEventListener('click', this.onClickSpin)

      this.sectors.forEach(this.drawSector)
      this.update()
      this.spin(0, 0)

      loading.hide()
    },
    async onClickSpin() {
      if (this.isSpinning || this.coin <= 0) return
      this.isSpinning = true

      const spinResult = await apiSpin.spin()
      if (spinResult.success) {
        const prizeIndex = this.sectors.findIndex(
          sector => sector.code === spinResult.result.code
        )
        this.coin = spinResult.result.remainingCoin
        this.elSpin.textContent = this.coin
        this.prize = spinResult.result.label
        // this.elSpin.style.font = '1.2rem sans-serif'

        this.engine()
        this.spin(prizeIndex)
      } else {
        this.$swal(
          i18n.t('modals.errorMsg'),
          i18n.t(`spin.error.${spinResult.error}`),
          'error'
        )
      }
    },
    async onClickClaim(coupon) {
      this.claimingCoupon = coupon
      this.modalClaimActive = true
    },
    drawSector(sector, i) {
      const ctx = this.ctx
      const rad = this.rad
      const ang = this.arc * i

      ctx.save()
      // COLOR
      ctx.beginPath()
      ctx.fillStyle = sector.color
      ctx.moveTo(rad, rad)
      ctx.arc(rad, rad, rad, ang, ang + this.arc)
      ctx.lineTo(rad, rad)
      ctx.fill()
      // TEXT
      ctx.translate(rad, rad)
      ctx.rotate(ang + this.arc / 2)
      ctx.textAlign = 'right'
      ctx.fillStyle = sector.textColor
      ctx.font = 'bold 18px sans-serif'
      ctx.fillText(sector.label, rad - 10, 10, 90)
      //
      ctx.restore()
    },
    async closeModalPrize() {
      this.modalPrizeActive = !this.modalPrizeActive
      this.disabledBodyScroll(this.modalPrizeActive)
      await this.setup()
    },
    async cancelModalClaim() {
      this.modalClaimActive = !this.modalClaimActive
      this.disabledBodyScroll(this.modalClaimActive)
    },
    async confirmModalClaim() {
      this.modalClaimActive = !this.modalClaimActive
      this.disabledBodyScroll(this.modalClaimActive)
      await this.setup()
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    },
    getIndex(ang) {
      return (
        Math.floor(this.tot - (this.mod(ang, this.TAU) / this.TAU) * this.tot) %
        this.tot
      )
    },
    update() {
      const currentProgress =
        this.spinAnimation?.effect.getComputedTiming().progress ?? 0

      const angDiff = this.ang - this.oldAng
      const angCurr = angDiff * currentProgress
      const angAbs = this.mod(this.oldAng + angCurr, this.TAU)

      const sectorIndexNew = this.getIndex(angAbs)
      if (this.sectorIndex !== sectorIndexNew) {
        // Sector changed! Make a tick sound
      }
      this.sectorIndex = sectorIndexNew
      this.elSpin.style.background = this.sectors[this.sectorIndex].color
      // this.elSpin.textContent = this.sectors[this.sectorIndex].label
    },
    engine() {
      this.update()
      this.animationFrameId = requestAnimationFrame(this.engine)
    },
    rand(m, M) {
      return Math.random() * (M - m) + m
    },
    mod(n, m) {
      return ((n % m) + m) % m
    },
    spin(index, duration) {
      // Remove this line if your slices (sectors)
      // are painted anti-clockwise
      index = this.tot - index

      // Absolute current angle (without turns)
      this.oldAng = this.ang
      const angAbs = this.mod(this.ang, this.TAU)

      // Absolute new angle
      let angNew = this.arc * index
      // (backtrack a bit to not end on the exact edge)
      angNew -= this.rand(0, this.arc)
      // Fix negative angles
      angNew = this.mod(angNew, this.TAU)

      // Get the angle difference
      const angDiff = this.mod(angNew - angAbs, this.TAU)

      // Add N full revolutions
      const rev = this.TAU * Math.floor(this.rand(2, 4))

      this.ang += angDiff + rev

      this.spinAnimation = this.elWheel.animate(
        [{ rotate: `${this.ang + this.angOffset}rad` }],
        {
          duration: duration ?? this.rand(4000, 5000) * rev * 0.1,
          easing: 'cubic-bezier(0.2, 0, 0.1, 1)',
          fill: 'forwards'
        }
      )

      this.spinAnimation.addEventListener(
        'finish',
        () => {
          this.spinAnimation = null
          cancelAnimationFrame(this.animationFrameId)
          this.elSpin.textContent = this.coin
          this.elSpin.style.font = '2rem sans-serif'
          this.elSpin.style.background = this.coin > 0 ? '#4e4f50' : '#666666'
          this.elSpin.style.cursor = this.coin > 0 ? 'pointer' : 'not-allowed'
          this.isSpinning = false

          if (this.prize) {
            this.modalPrizeActive = true
          }
        },
        { once: true }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.spinwheel {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

#wheelOfFortune {
  display: inline-flex;
  position: relative;
  overflow: hidden;
}

#wheel {
  display: block;
  user-select: none;
}

#spin {
  font: 1.2rem sans-serif;
  user-select: none;
  cursor: pointer;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 35%;
  background: #fff;
  color: #fff;
  box-shadow: 0 0 0 8px currentColor, 0 0px 15px 5px rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  transition: 0.25s;
  -webkit-tap-highlight-color: transparent;
  text-transform: uppercase;
  white-space: pre-line;
}

#spin::after {
  content: '';
  position: absolute;
  top: -17px;
  border: 10px solid transparent;
  border-bottom-color: currentColor;
  border-top: none;
}

.coupon-table td,
.coupon-table th {
  vertical-align: middle !important;
}
</style>
